import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  
  private currentUserIdentifier: string | null = null;  // This will store the MyKad number or equivalent

  constructor() { }

  // Set the current user's identifier (call this after successful login)
  setCurrentUserIdentifier(identifier: string): void {
    this.currentUserIdentifier = identifier;
  }

  // Get the current user's identifier
  getCurrentUserIdentifier(): string | null {
    return this.currentUserIdentifier;
  }

  // Clear the current user's identifier (call this on logout)
  clearCurrentUserIdentifier(): void {
    this.currentUserIdentifier = null;
  }
}